import {Card, CardContent, CardMedia, Stack, Typography} from "@mui/material";
import {CustomWorldDocument} from "../../../../types/pj1dbApiWorld";

export interface CustomWorldListItemProps {
  item: CustomWorldDocument;
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
}

export function CustomWorldListItem(props: CustomWorldListItemProps) {
  return (
    <Card sx={{width: 240}}>
      <CardMedia
        component="img"
        height="145"
        image={props.item.url?.thumbnail}
        alt={props.item.attr['name-jp']}
        sx={{objectFit: "scale-down"}}
      />
      <CardContent sx={{p: 1, m: 0, textWrap: 'nowrap', overflowX: 'scroll'}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p'>
            ベースワールド名：{props.item.attr['name-jp']}
          </Typography>
          {props.children}
        </Stack>
      </CardContent>
    </Card>
  )
}
